export enum QueryKeys {
	Permissions = "PERMISSION_QUERY",
	Systems = "SYSTEMS_QUERY",
	AllSystems = "ALL_SYSTEMS_QUERY",
	User = "USER_QUERY",
	Shifts = "SHIFT_QUERY",
	ShiftDetails = "SHIFT_DETAILS_QUERY",
	ShiftColleagues = "SHIFT_COLLEAGUES_QUERY",
	AbsenceTypes = "ABSENCE_TYPES_QUERY",
	AbsenceRequestDelete = "ABSENCE_REQUEST_DELETE_QUERY",
	Holidays = "HOLIDAYS_QUERY",
	Availability = "AVAILABILITY_QUERY",
	AvailabilityCreate = "AVAILABILITY_CREATE_QUERY",
	EmployeeSettings = "EMPLOYEE_SETTINGS_QUERY",
	TradeableShifts = "TRADEABLE_SHIFT_QUERY",
	SystemNews = "SYSTEM_NEWS_QUERY",
	SystemNewsUnreadCount = "SYSTEM_NEWS_UNREAD_COUNT_QUERY",
	SystemNewsRead = "SYSTEM_NEWS_READ_QUERY",
	SystemNewsUnread = "SYSTEM_NEWS_UNREAD_QUERY",
	SystemNewsAttachment = "SYSTEM_NEWS_ATTACHMENT_QUERY",
	News = "NEWS_QUERY",
	Salary = "SALARY_QUERY",
	SalaryPdf = "SALARY_PDF_QUERY",
	TimeReport = "TIME_REPORT_QUERY",
	Tips = "TIPS_QUERY",
	CompanyInformationProperties = "COMPANYINFORMATIONPROPERTIES_QUERY",
	ScheduleConsent = "SCHEDULE_CONSENT_QUERY",
	Documents = "DOCUMENTS_QUERY",
	DocumentFileUpload = "DOCUMENT_FILE_UPLOAD_QUERY",
	ClockIn = "CLOCK_IN_QUERY",
	ClockWorkingShifts = "CLOCK_WORKING_SHIFT_QUERY",
	Stations = "STATIONS_QUERY",
	Messages = "MESSAGES_QUERY",
	MessageUnread = "MESSAGE_UNREAD_QUERY",
	MessageAttachment = "MESSAGE_ATTACHMENT_QUERY",
	ApplicationShift = "SHIFT_APPLICATION_QUERY",
	Devices = "DEVICES_QUERY",
	DevicesDelete = "DEVICES_DELETE_QUERY",
	PushNotificationIsActivated = "PUSH_ACTIVATED_QUERY",
	PushNotificationActiveInOS = "PUSH_ACTIVATED_BY_OS_QUERY",
	IsoCountries = "ISO_COUNTRIES",
	PeriodOverview = "PERIODOVERVIEW_QUERY",
	PeriodList = "PERIOD_LIST_QUERY",
	GetEmploymentsContractsInfo = "EMPLOYMENTS_CONTRACTS_INFO_QUERY",
	TimereportAddShift = "TIME_REPORT_ADD_SHIFT_QUERY",
	TimereportAddShiftFromSchedule = "TIME_REPORT_ADD_SHIFT_FROM_SCHEDULE_QUERY",
	TimereportDeleteShift = "TIME_REPORT_DELETE_SHIFT_QUERY",
	BffUser = "BFF_USER_QUERY",
}
